<div class="container request-payment-type" *ngIf="paymentMethod">
    <!--local payments-->
    <div class="carded mony-currency"
        *ngIf="paymentMethod.localPayemnts && paymentMethod.localPayemnts.methods.length>0">
        <mat-accordion>
            <mat-expansion-panel [expanded]="true" disabled="true">
                <mat-expansion-panel-header collapsedHeight="60px" expandedHeight="60px">
                    <mat-panel-title>
                        {{paymentMethod.localPayemnts.name}}
                    </mat-panel-title>
                    <button class="btn-tc size-sm btn-secondary-new btn-has-one-icon radius-full" [disableRipple]="true"
                        appMousePress (click)="openRequests('money-currency')" mat-stroked-button>
                        {{'REQUEST.REQUESTS' | translate}}
                        <i class="fa-solid fa-chevron-left"></i>
                    </button>
                </mat-expansion-panel-header>
                <tc-inline-alert *ngIf="paymentMethod && !paymentMethod.localPayemnts['enable']"
                    [type]="inlineAlertTypes.info" [text]="paymentMethod.localPayemnts['stateMessage']">
                </tc-inline-alert>

                <div class="body">

                    @for (item of paymentMethod.localPayemnts.methods; track $index) {
                    @if(requestType === requestTypes.Send && item.type === paymentType.ONLINE){

                    }@else {
                    <div (click)="selectPaymentMethod(item)" class="main-service"
                        [ngClass]="{'deactive': !paymentMethod.localPayemnts['enable']}">
                        <div class="new" *ngIf="item.isNew">
                            <span>
                                {{'REQUEST.DEPOSIT.BY_ID.NEW' | translate}}
                            </span>
                        </div>
                        <div class="img">
                            <img [src]="item.lightIcon">
                        </div>
                        <div class=" title ">
                            <span>{{ item.name }}
                                <ng-container *ngIf="requestType === requestTypes.Send">
                                    {{'REQUEST.SEND.TO_TC' | translate}}</ng-container>
                            </span>
                        </div>
                    </div>
                    }
                    }
                </div>

            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <!--tc wallet-->
    <div class="carded mony-currency" *ngIf="paymentMethod.tcWallet && paymentMethod.tcWallet.methods.length>0">
        <mat-accordion>
            <mat-expansion-panel [expanded]="true" disabled="true">
                <mat-expansion-panel-header collapsedHeight="60px" expandedHeight="60px">
                    <mat-panel-title>
                        {{paymentMethod.tcWallet.name}}
                    </mat-panel-title>
                    <button class="btn-tc size-sm btn-secondary-new btn-has-one-icon radius-full" [disableRipple]="true"
                        appMousePress (click)="openRequests('tc-wallet')" mat-stroked-button>
                        {{'REQUEST.REQUESTS' | translate}}
                        <i class="fa-solid fa-chevron-left"></i>
                    </button>
                </mat-expansion-panel-header>
                <tc-inline-alert *ngIf="paymentMethod && !paymentMethod.tcWallet['enable']"
                    [type]="inlineAlertTypes.info" [text]="paymentMethod.tcWallet['stateMessage']"></tc-inline-alert>

                <div class="body">
                    <div *ngFor="let item of paymentMethod.tcWallet.methods" (click)="selectTcWalletPaymentMethod(item)"
                        class="main-service" [ngClass]="{'deactive': !paymentMethod.tcWallet['enable']}">
                        <div class="img">
                            <img [src]="item.lightIcon">
                        </div>
                        <div class=" title ">
                            <span>{{ item.name }}
                            </span>
                        </div>
                    </div>
                </div>

            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <!--crypto-->
    <div class="carded digital-currency " *ngIf="paymentMethod.crypto && paymentMethod.crypto.methods.length>0">
        <mat-accordion>
            <mat-expansion-panel [expanded]="true " disabled="true ">
                <mat-expansion-panel-header collapsedHeight="60px " expandedHeight="60px ">
                    <mat-panel-title>
                        {{paymentMethod.crypto.name}}
                    </mat-panel-title>
                    <button class="btn-tc size-sm btn-secondary-new btn-has-one-icon radius-full" [disableRipple]="true"
                        appMousePress mat-stroked-button (click)="openRequests('crypto')">
                        {{'REQUEST.REQUESTS' | translate}}
                        <i class="fa-solid fa-chevron-left"></i>
                    </button>
                </mat-expansion-panel-header>
                <tc-inline-alert *ngIf="paymentMethod && !paymentMethod.crypto['enable']" [type]="inlineAlertTypes.info"
                    [text]="paymentMethod.crypto['stateMessage']"></tc-inline-alert>

                <div class="body ">
                    <div *ngFor="let item of paymentMethod.crypto.methods" class="service-container ">
                        <div class="main-service" [ngClass]="{'deactive': !paymentMethod.crypto['enable']}"
                            (click)="clickCrypto(item) ">
                            <div class="img ">
                                <img [src]="item.lightIcon">
                            </div>
                            <div class="title ">
                                <span>{{item.name}}</span>
                            </div>
                        </div>
                    </div>
                </div>

            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <!--emoney-->
    <div class="carded digital-currency " *ngIf="paymentMethod.eMoney && paymentMethod.eMoney.methods.length>0">
        <mat-accordion>
            <mat-expansion-panel [expanded]="true " disabled="true ">
                <mat-expansion-panel-header collapsedHeight="60px " expandedHeight="60px ">
                    <mat-panel-title>
                        {{paymentMethod.eMoney.name}}
                    </mat-panel-title>
                    <button class="btn-tc size-sm btn-secondary-new btn-has-one-icon radius-full" [disableRipple]="true"
                        appMousePress mat-stroked-button (click)="openRequests('electronic-money')">
                        {{'REQUEST.REQUESTS' | translate}}
                        <i class="fa-solid fa-chevron-left"></i>
                    </button>
                </mat-expansion-panel-header>
                <div class="body ">
                    <div *ngFor="let item of paymentMethod.eMoney.methods" class="service-container "
                        [ngClass]="{ 'show-sub-service': item.showSub} ">
                        <div class="main-service " [ngClass]="{'deactive': !paymentMethod.eMoney['enable']}"
                            (click)="clickEMoney(item)">
                            <div class="img ">
                                <img [src]="item.lightIcon ">
                            </div>
                            <div class="title ">
                                <span>{{item.serviceName}}</span>
                            </div>
                        </div>
                        <div *ngIf="item.hasSubService " class="sub-service ">
                            <div class="head ">
                                <span>{{item.serviceName}}</span>
                            </div>
                            <tc-table-loading *ngIf="servicesIsLoading && item['showSub']"></tc-table-loading>
                            <i class="icon-cancel icon " (click)="hideSubService(item) "></i>
                            <mat-radio-group class="type " [(ngModel)]="selectedService ">
                                <mat-radio-button class="radio-button-new" *ngFor="let subService of subServices "
                                    [value]="subService ">
                                    {{subService.serviceName}}
                                </mat-radio-button>
                            </mat-radio-group>

                            <div class="next-button">
                                <button mat-flat-button class="btn-tc size-sm btn-primary-new" [disableRipple]="true"
                                    appMousePress [ngClass]="{'deactive': !selectedService}"
                                    [disabled]="!selectedService" (click)="selectEmoney()">{{'GENERAL.NEXT' |
                                    translate}}</button>
                            </div>


                        </div>

                    </div>
                </div>

            </mat-expansion-panel>
        </mat-accordion>
    </div>

</div>

<tc-table-loading *ngIf="isLoading"></tc-table-loading>